import React from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
  FormControl,
  CircularProgress,
  InputLabel,
  Select,
  MenuItem
} from '@material-ui/core';
import axios from 'axios';
import { CorporateAccountNames, ConsumerAccountNames } from 'common/Constants.js';
import { Chart as SankeyChart} from 'react-google-charts';
import { getDynamicConfigValue } from '../../dynamicConfig';
import { getKeymakerApiKey } from "../../graphql/keymakerApiKey";

/*
 *
 *
 *
 * DASHBOARD COMPONENT
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
export default function CircularPayment(props) {
  const { value, handleChange, _, TabPanel, setMode } = props;

  const [sankeyLoading, setSankeyLoading] = React.useState(false);
  const [sankeyAccountType, setSankeyAccountType] = React.useState('Consumer');
  const [sankeyName, setSankeyName] = React.useState('jiacheng, liu');
  const [sankeyData, setSankeyData] = React.useState();

  React.useEffect(() => {
    fetchSankeyData();
  }, [sankeyName]);

  const getSankeyData = async (phaseID, name) => {
    const res = await axios
      .post(getDynamicConfigValue("REACT_APP_RECOMMENDATION_URI"), {
        query: `
                  query {
                    recommendations(
                      first: 1000,
                      skip: 0,
                      engineID: "aml-circular-payment",
                      params: {accountName: "${name}"
                      }) {
                      item
                      score
                      details
                    }
                  }
              `
      },
      {        
        headers: { 
          "api-key": getKeymakerApiKey()
        }
      })
      .catch(err => console.log(err));
    return res.data ? res.data.data.recommendations : null;
  };

  const fetchSankeyData = async id => {
    setSankeyLoading(true);
    const data = await getSankeyData(id, sankeyName);
    if (data) {
      const processed = prepareSankeyData(data);
      setSankeyData(processed);
    }
    setSankeyLoading(false);
  };

  const prepareSankeyData = data => {
    var map = {};
    var d = [['From', 'To', 'Weight']];
    if (!data[0]) {
      return;
    }
    const paths = data[0].details.paths;
    for (let i = 0; i < paths.length; i++) {
      const score = 1;
      const path = paths[i];
      for (let j = 0; j < path.length - 1; j++) {
        const from = path[j] + `(${j})`;
        let to;
        if (path.length - 1 === j + 1) {
          to = path[j + 1];
        } else {
          to = path[j + 1] + `(${j + 1})`;
        }
        if (from + to in map) {
          map[from + to] = [from, to, map[from + to][2] + score];
        } else {
          map[from + to] = [from, to, score];
        }
      }
    }
    Object.keys(map).forEach(k => {
      d.push(map[k]);
    });
    return d;
  };

  // RENDER
  return (
    <div>
      <Grid
        container
        item
        xs={12}
        style={{
          padding: '48px',
          borderRadius: '3px',
          border: '1px solid rgba(0, 0, 0, 0.25)'
        }}>
        <Grid item xs={6}>
          <div
            style={{
              fontSize: '20px',
              fontWeight: 'bold'
            }}>
            Circular Payments Of Top 10 Accounts
          </div>
        </Grid>
        <Grid item xs={6}>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <FormControl variant="outlined">
              <InputLabel>Account Type</InputLabel>
              <Select
                style={{ minWidth: '150px' }}
                value={sankeyAccountType}
                onChange={e => {
                  setSankeyAccountType(e.target.value);
                  e.target.value === 'Consumer'
                    ? setSankeyName(ConsumerAccountNames[0])
                    : setSankeyName(CorporateAccountNames[0]);
                }}
                label="Account Type">
                <MenuItem value={'Consumer'}>Consumer</MenuItem>
                <MenuItem value={'Corporate'}>Corporate</MenuItem>
              </Select>
            </FormControl>
            <div style={{ width: '24px' }} />
            <FormControl variant="outlined">
              <InputLabel>Account Name</InputLabel>
              <Select
                value={sankeyName}
                onChange={e => {
                  setSankeyName(e.target.value);
                }}
                label="Account Name">
                {sankeyAccountType === 'Consumer'
                  ? ConsumerAccountNames.map((name, idx) => (
                      <MenuItem key={idx} value={name}>
                        {name}
                      </MenuItem>
                    ))
                  : CorporateAccountNames.map((name, idx) => (
                      <MenuItem key={idx} value={name}>
                        {name}
                      </MenuItem>
                    ))}
              </Select>
            </FormControl>
          </div>
        </Grid>
        <div style={{ height: '64px' }} />
        <Grid item xs={12}>
          {sankeyLoading && <CircularProgress color="secondary" />}
          {!sankeyLoading && !sankeyData && <div>No data available</div>}
          {!sankeyLoading && sankeyData && (
            <SankeyChart
              width={'100%'}
              height={'500px'}
              chartType="Sankey"
              loader={<CircularProgress color="secondary" />}
              data={sankeyData}
              rootProps={{ 'data-testid': '1' }}
            />
          )}
        </Grid>
      </Grid>
    </div>
  );
}

CircularPayment.propTypes = {
  value: PropTypes.number.isRequired,
  handleChange: PropTypes.func.isRequired,
  a11yProps: PropTypes.func.isRequired,
  TabPanel: PropTypes.func.isRequired
};
